<!-- Describe the template of the smash-tooltip here-->
<!-- [@animateTooltip]="{value: state, params: { startPosition: startPosition,  endPosition: endPosition }}" -->
<div class="smash-tooltip-container" [@animateTooltip]="{value: state, params: { startPosition: startPosition,  endPosition: endPosition }}" *ngIf="displayed">
    <div class ="smash-tooltip" [ngClass]="{'smash-tooltip-top': position === 'top', 'smash-tooltip-bottom': position === 'bottom'}">
        <ng-content class="smash-tooltip-content">
            <!-- Ng-content balise describes the content of the tooltip. -->
        </ng-content>
    </div>
</div>
